define('CoreChargeItem.Helper', [
    'underscore'
], function CoreChargeItemHelper(
    _
) {
    'use strict';

    return {
        isCoreChargeFeeItem: function isCoreChargeFeeItem(item) {
            return item && item.itemtype === 'Service' &&
            item.custitem_corechargeitem && _.isEmpty(item.custitem_rp_core_charge_item_id);
        }
    };
});
